import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addCard: {
    id: 'DirectOffer.Creator.addCard',
    defaultMessage: 'Add a Card',
  },
});
